import * as postsApi from '@/api/posts'

const state = {
  posts: [],
  pending: [],
  current: null,
  loading: false,
}

const getters = {
  posts: (state) => state.posts,
  pending: (state) => state.pending,
  current: (state) => state.current,
  loading: (state) => state.loading,
}

const actions = {
  async fetchPosts({ commit }, params = {}) {
    commit('SET_LOADING', true)
    try {
      const { data } = await postsApi.listPosts(params)
      commit('SET_POSTS', data.data.posts || [])
      return data.data.posts
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchPending({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await postsApi.listPendingApproval()
      commit('SET_PENDING', data.data.posts || [])
      return data.data.posts
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchPost({ commit }, id) {
    const { data } = await postsApi.getPost(id)
    commit('SET_CURRENT', data.data.post)
    return data.data
  },

  async fetchPostComments(_, id) {
    const { data } = await postsApi.getPostComments(id)
    return data.data
  },

  async createPost(_, payload) {
    const { data } = await postsApi.createPost(payload)
    return data.data.post
  },

  async updatePost(_, { id, payload }) {
    const { data } = await postsApi.updatePost(id, payload)
    return data.data.post
  },

  async schedulePost(_, { id, scheduledAt }) {
    const { data } = await postsApi.schedulePost(id, { scheduled_at: scheduledAt })
    return data.data.post
  },

  async publishPost(_, id) {
    const { data } = await postsApi.publishPost(id)
    return data.data.post
  },

  async deletePost(_, id) {
    await postsApi.deletePost(id)
  },

  async approvePost(_, { id, scheduledAt }) {
    const payload = scheduledAt ? { scheduled_at: scheduledAt } : {}
    const { data } = await postsApi.approvePost(id, payload)
    return data.data.post
  },

  async rejectPost(_, { id, reason }) {
    const { data } = await postsApi.rejectPost(id, { reason })
    return data.data.post
  },

  async uploadMedia(_, file) {
    const { data } = await postsApi.uploadMedia(file)
    return data.data
  },
}

const mutations = {
  SET_POSTS(state, posts) { state.posts = posts },
  SET_PENDING(state, posts) { state.pending = posts },
  SET_CURRENT(state, post) { state.current = post },
  SET_LOADING(state, loading) { state.loading = loading },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
